module.exports = __webpack_public_path__ + "static/media/Willas_client_page_(optimized)2.881cae63.png";